import { render } from "./shapes.vue?vue&type=template&id=5874dfcf&scoped=true"
import script from "./shapes.vue?vue&type=script&lang=js"
export * from "./shapes.vue?vue&type=script&lang=js"

import "./shapes.vue?vue&type=style&index=0&id=5874dfcf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5874dfcf"]])

export default __exports__